export enum TButtonAndLinkDesigns {
  LocalLinkPrim = 'LocalLinkPrim',
  LocalLinkSec = 'LocalLinkSec',
  LocalBttnPrim = 'LocalBttnPrim',
  LocalBttnSec = 'LocalBttnSec',
  LocalBttnSecTransp = 'LocalBttnSecTransp',
  LocalBttnSecHalfTransp = 'LocalBttnSecHalfTransp',
  LocalBttnSecInverted = 'LocalBttnSecInverted',
  LocalBttnCritical = 'LocalBttnCritical',
  LocalBttnLiquidGlass = 'LocalBttnLiquidGlass',
}
